<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="价值排行榜" name="0">
                <quarterBank></quarterBank>
            </el-tab-pane>
            <el-tab-pane label="本人月度价值汇总" name="1" lazy="true">
                <quarterTotal></quarterTotal>
            </el-tab-pane>
            <el-tab-pane label="季度评估" name="2" lazy="true">
                <quarterForm></quarterForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import quarterForm from '@/components/cooperative/quarterForm'
    import quarterBank from '@/components/cooperative/quarterKpiBank'
    import quarterTotal from '@/components/cooperative/quarterKpiTotal'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0'
            }
        },
        components:{
            quarterForm,quarterBank,quarterTotal

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/quarterkpi.vue